import Text, { Paragraph, Label, HtmlText } from './text';
import { sizes } from './style';

export { Text, Paragraph, Label, HtmlText, sizes };
export type { TextProps } from './text';

export default Text;
